import { createStore } from 'vuex';
import { EventEmitter } from 'events';
import { AuthorizedUser } from '../models/authorized-user';
import snackBarStoreModule from '@/shared/components/snackbar/snack-bar-store-module';
import popOverStoreModule from '@/shared/components/popover/popover-store-module';
import complianceFormStoreModule from './compliance-form-store-module';
import managePracticeSignatoriesStoreModule from './manage-practice-signatory-store-module';

export default createStore({
  modules: {
    popOverStoreModule,
    snackBarStoreModule,
    complianceFormStoreModule,
    managePracticeSignatoriesStoreModule
  },
  state: {
    authorizedUser: new AuthorizedUser(),
    eventController: new EventEmitter(),
  },
  mutations: {
    setUserAccount(state, authorizedUser: AuthorizedUser) {
      state.authorizedUser = authorizedUser;
    },
  },
  actions: { // store.dispatch
    setUserAccount({ commit }, authorizedUser: AuthorizedUser) {
      commit('setAuthorizedUser', authorizedUser);
    }
  },
  getters: {
    getUserAccount: (state) => state.authorizedUser,
    getEventController: (state) => state.eventController,
  }
})
